import { useState, useEffect, useRef, memo } from "react";
import "../css/Screen2.css";
import { AzureCommunicationTokenCredential } from "@azure/communication-common";
import axios from "axios";
import {
  LocalVideoStream,
  VideoStreamRenderer,
} from "@azure/communication-calling";
import TopProgressBar from "../Sub_components/TopProgressBar";
import {
  CallProvider,
  CallAgentProvider,
  DEFAULT_COMPONENT_ICONS,
  useDeviceManager,
} from "@azure/communication-react";
import ChatScreen from "../Components/ChatScreen";
import MediaDeviceSelector from "../Sub_components/MediaDeviceSelector";
import Navbar from "../Components/Navbar"
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { initializeIcons, registerIcons } from "@fluentui/react";
import AttendeeList from "../Components/AttendeeList";
import VideoGalleryScreen from "./VideoGalleryScreen";
import { useNavigate } from "react-router-dom";
import { AmplitudeAddLog } from "../utils/AppAmplitude";
import BodyClassUpdater from "../utils/BodyClassUpdater";
import ChatInitialize from "../GeneralFunctions/ChatInitialize";
import PermissionsFetch from "../GeneralFunctions/PermissionsFetch";
import SendPlayerSettings from "../GeneralFunctions/SendPlayerSettings";

initializeIcons();
const customIcons = {
  ...DEFAULT_COMPONENT_ICONS,
  ControlBarChatButtonActive: (
    <i className={`icon font-awesome-light-pro va-comment-lines`}></i>
  ),
  ControlBarChatButtonInactive: <i className="fa-regular fa-comment-slash"></i>,
  PeoplePaneAddPerson: <i className="fa-solid fa-user"></i>,
  IncomingCallNotificationAcceptWithVideoIcon: (<i className="fa-regular fa-video-slash"></i>),
  ErrorBarCallVideoStoppedBySystem: (<i className="fa-regular fa-video"></i>),
  ErrorBarCallMicrophoneMutedBySystem: (<svg fill="currentColor" className="___12fm75w_v8ls9a0 f1w7gpdv fez10in fg4l7m0" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M13 10a3 3 0 0 1-.1.78L7 4.88A3 3 0 0 1 13 5v5ZM7 7.7V10a3 3 0 0 0 4.74 2.45l1.07 1.07A4.5 4.5 0 0 1 5.5 10a.5.5 0 0 0-1.01 0 5.5 5.5 0 0 0 5 5.48v2.02a.5.5 0 0 0 1 0v-2.02a5.48 5.48 0 0 0 3.02-1.25l3.63 3.62a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7L7 7.71Zm7.8 4.98c.45-.8.7-1.7.7-2.68a.5.5 0 0 0-1 0c0 .7-.16 1.35-.44 1.94l.74.74Z" fill="currentColor"></path></svg>
  ),
  UnpinParticipant: <i className="fa-regular fa-thumbtack-slash"></i>,
  VideoTilePinned: <i className="fa-regular fa-thumbtack"></i>
};
registerIcons({ icons: customIcons });
function ClassSessionScreen({ vertualFocusedContent, setVertualFocusedContent, setIsContextualMenuOpen }) {

  const {
    token,
    userName,
    communicationUserId,
    role,
    isCam,
    setIsCam,
    isMic,
    setServerCallId,
    setArrRemoteParticipants,
    camera,
    setCamera,
    roomId,
    threadId,
    hostCommunicationUserId,
    isHostNotJoined,
    ArrRemoteParticipants,
    setIsHostNotJoined,
    sessionStartTimeUTC,
    chatThreadClientRef,
    errorMessage,
    callN,
    setLoaderAnimation,
    attendeeList,
    appInsightTrack,
    __merchantId,
    __userId,
    setErrorMessage,
    statefulCallClient,
    __appConfirmUniqueID,
    grp,
    isInstructorModeRef,
    speaker,
    microphone,
    serverCallId,
    speakers,
    microphones,
    businessURL,
    chatColor,
    setChatColor,
    messages,
    toggleStates,
    setIsMic,
    loaderAnimation,
    apiUrlPost
  } = useLiveStreamAppContext();

  //Local States of the Components
  const panelRef = useRef(null);
  const [call, setCall] = useState(null);
  const [navbarOptionMenu, setNavbarOptionMenu] = useState("");
  const [isActive, setIsActive] = useState("")
  const disableChatRef = useRef(false);
  const [isSharing, setIsSharing] = useState(false);
  const streamRef = useRef(null);
  const videoRef = useRef(null);
  const [localVideoStream, setLocalVideoStream] = useState(null);
  const [callAgent, setCallAgent] = useState(null);
  const [layout, setLayout] = useState("floatingLocalVideo");
  const [hostBeRightBack, setHostBeRightBack] = useState(false);
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to track dropdown
  const deviceManager = useDeviceManager();
  const [expendVideoTile, setExpendVideoTile] = useState(false);
  let countRef = useRef(0);
  const { ChatInitialization } = ChatInitialize();
  const { checkPermissions } = PermissionsFetch();
  const { setplayersettings } = SendPlayerSettings();

  const headers = {
    "Content-Type": "application/json",
    userId: __userId,
    merchantId: __merchantId
  };
  const handleCallLog = async (newCallId) => {
    try {
      const payload = {
        appUniqueConfirmId: __appConfirmUniqueID,
        callId: newCallId
      };

      await axios.post(
        `${apiUrlPost}savecalldetails`,
        payload,
        { headers }
      );

      // Dispose or reset sensitive data after use
      payload.appUniqueConfirmId = null;
      payload.callId = null;
    } catch (error) {
      console.error("Error in savecalldetails:", error);
      appInsightTrack(__merchantId, __userId, "API Error savecalldetails", "", error);
    }
  };
  //Function to start the Call agent for ACS Services
  const initializeCallAgent = async () => {
    //console.log("initializeCallAgent Started");
    try {
      if (callAgent) {
        callAgent.dispose();
      }
      const tokenCredential = new AzureCommunicationTokenCredential(token);
      setCallAgent(await statefulCallClient.createCallAgent(
        tokenCredential,
        {
          displayName: userName,
          role: "Presenter",
        }
      ));
    } catch (error) {
      if (error.message.includes("Invalid token specified")) {
        setLoaderAnimation(false);
        setErrorMessage("Invalid Token");
      }
      console.error("Error initializing call agent:", error);
      appInsightTrack(__merchantId, __userId, "Error initializing Call Agent", "", error);
    }
  };

  // Call setplayersettings when toggleStates changes    
  useEffect(() => {
    if (role === "Presenter") {
      setplayersettings();
    }
  }, [
    toggleStates.StartRecording,
    toggleStates.EnableMic,
    toggleStates.EnableVideo,
    toggleStates.EnableChat,
    toggleStates.EnableScreenShare,
    toggleStates.blurBackground,
    toggleStates.removeBackgroundNoise,
    toggleStates.shareDeviceAudio,
  ]);

  useEffect(() => {
    AmplitudeAddLog(__userId, __merchantId, businessURL, 108, grp, __appConfirmUniqueID);
  }, [__userId])

  useEffect(() => {
    if (communicationUserId && statefulCallClient) {
      initializeCallAgent();
    }
  }, [statefulCallClient]);

  useEffect(() => {
    if (role !== "Presenter") {
      if (
        ArrRemoteParticipants?.some(
          (participant) =>
            participant.identifier.communicationUserId ===
            hostCommunicationUserId
        )
      ) {
        setHostBeRightBack(false);
        setIsHostNotJoined(false);
      } else {
        if (!isHostNotJoined) {
          setNavbarOptionMenu("");
          setIsActive("")
          setHostBeRightBack(true);
          setIsMic(false);
        }
      }
    }
  }, [ArrRemoteParticipants]);

  useEffect(() => {
    try {
      if (attendeeList && attendeeList[0]?.communicationUserId) {
        ChatInitialization();
      }
    } catch (error) {
      console.error("Error Fetching Attendee list:", error);
      appInsightTrack(__merchantId, __userId, "Error Fetching Attendee list", "", error);
    }
  }, [token]);



  useEffect(() => {
    if (role === "Attendee" && isInstructorModeRef.current && callN.current) {
      !callN.current?.isMuted && callN.current?.mute();
      callN.current?.isLocalVideoStarted && callN.current?.stopVideo(localVideoStream);
    }
  }, [isInstructorModeRef.current, callN.current]);

  useEffect(() => {
    const selectSpeaker = async () => {
      if (!deviceManager || !speaker) return;
      // Speaker selection is unsupported on some platforms (Android browsers, iOS Safari) -
      // the OS controls audio routing there and selectSpeaker would throw
      if (deviceManager.isSpeakerSelectionAvailable === false) return;
      //console.log("Speaker useEffect called");
      try {
        const a = await deviceManager.getSpeakers();
        deviceManager?.selectSpeaker(a.find(e => e.id === "speaker:" + speaker));
      } catch (error) {
        console.error("Error selecting speaker:", error);
        appInsightTrack(__merchantId, __userId, "Error selecting Speaker", "", error);
      }
    };

    selectSpeaker();
  }, [speaker, speakers, deviceManager]);

  useEffect(() => {
    const selectMicrophone = async () => {
      if (!deviceManager || !microphone) return;
      //console.log("Microphone useEffect called");
      try {
        let microphones = await deviceManager.getMicrophones();
        deviceManager.selectMicrophone(microphones.find(e => e._id === "microphone:" + microphone));
      } catch (error) {
        console.error("Error selecting microphone:", error);
        appInsightTrack(__merchantId, __userId, "Error selecting microphone", "", error);
      }
    };
    selectMicrophone();
  }, [microphone, microphones, deviceManager]);


  useEffect(() => {
    // initializeDeviceManager()
    if (sessionStorage.getItem("end")) {
      setLoaderAnimation(true)
      const currentPath = window.location.pathname;
      const newPath = currentPath.replace("/meeting", "/start");
      navigate(newPath + window.location.search);
      setLoaderAnimation(false)
    }
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (!(navigator.userAgent.indexOf("com.vagaro.customerios") > -1) || !(/iPhone|iPad|Macintosh/i.test(userAgent) && (navigator.maxTouchPoints || 0) > 1)) {
      checkPermissions();
    }
    if (loaderAnimation) {
      setLoaderAnimation(false);
    }
  }, []);


  useEffect(() => {
    if (callAgent && deviceManager && role) {
      joinRoomCall();

      // Function to handle the event subscription and cleanup
      const handleCallStateChanged = (addedCall) => {

        addedCall.on("stateChanged", async () => {
          if (addedCall.state === "Connected") {
            // console.log("1. Call has Connected");
            try {
              // Retry fetching serverCallId if not available immediately
              let retries = 5;
              let serverCallId = null;
              while (retries > 0 && !serverCallId) {
                serverCallId = await addedCall.info.getServerCallId().catch(() => null);
                if (!serverCallId) {
                  retries--;
                  // console.log("Retrying to get ServerCallId, attempts remaining:", retries);
                  await new Promise(resolve => setTimeout(resolve, 3000));
                }
              }
              if (serverCallId) {
                setServerCallId(serverCallId);
              } else {
                console.error("Failed to get ServerCallId after multiple retries");
              }
            } catch (error) {
              console.error("Error getting server call ID:", error);
              appInsightTrack(__merchantId, __userId, "Error Fetching ServerCallId", "", error);
            }
          }
        });
      };

      if (role === "Presenter" && (serverCallId === "" || serverCallId === null)) {
        callAgent.on("callsUpdated", (e) => {
          e.added.forEach(handleCallStateChanged);
        });
      }

      // Cleanup function to remove event listeners
      return () => {
        if (role === "Presenter") {
          callAgent.off("callsUpdated", (e) => {
            e.added.forEach(handleCallStateChanged);
          });
        }
      }
    }
  }, [callAgent, deviceManager, role]);

  useEffect(() => {
    if (isSharing && streamRef.current) {
      videoRef.current.srcObject = streamRef.current;
    }
  }, [isSharing, streamRef]);

  const handleClickOutside = (event) => {
    if (panelRef.current && !panelRef.current.contains(event.target)) {
      setNavbarOptionMenu(""); // Close the panel if clicked outside
      setIsActive("")
    }
  };

  const handleSelect = (option) => {
    if (navbarOptionMenu === option) {
      setIsActive("")
    } else {
      setIsActive(option)
    }
    setNavbarOptionMenu((prevSelected) =>
      prevSelected === option ? "" : option
    );
    //console.log("Handle Select Function End");
  };

  useEffect(() => {
    if (navbarOptionMenu.length > 0) {
      !document.body.classList.contains("video-screenwidth") && document.body.classList.add("video-screenwidth");
    } else {
      document.body.classList.contains("video-screenwidth") && document.body.classList.remove("video-screenwidth")
    }

    let vg = document.getElementById("videoGallery");
    if (vg) {
      vg.addEventListener("mousedown", handleClickOutside);
      return () => {
        vg.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [navbarOptionMenu]);


  const joinRoomCall = async () => {
    //console.log("Join Room Call Start");
    try {
      let localVideoStream = null;

      if (!isInstructorModeRef.current && isCam) {
        localVideoStream = await createLocalVideoStream();
      }
      const roomCallLocator = {
        roomId: roomId,
      };

      const videoOptions = localVideoStream
        ? { localVideoStreams: [localVideoStream] }
        : undefined;
      const newCall = callAgent.join(roomCallLocator, { videoOptions });
      setCall(newCall);
      callN.current = newCall;
      setArrRemoteParticipants(newCall?.remoteParticipants)

      if (isMic === false || hostBeRightBack || isHostNotJoined) {
        try {
          if (!newCall.isMuted) newCall.mute();
        } catch (error) {
          console.error("Error Muting Mic", error);
          appInsightTrack(__merchantId, __userId, "Error Muting mic", "", error);
        }
      }
      setTimeout(() => {
        if (newCall.id) {
          console.log("Call Id:", newCall.id);
          handleCallLog(newCall.id);
        }
      }, 1000);  
    } catch (error) {
      console.error(error);
      appInsightTrack(__merchantId, __userId, "Error in joinRoomCall", "", error);
    }
    return () => {
      callAgent.dispose();
    }
  };

  useEffect(() => {
    const handleCameraChange = async () => {
      try {
        if (!call) {
          return;
        }
        let videoStream = call.localVideoStreams.find((stream) => {
          return stream.mediaStreamType === "Video";
        });

        if (videoStream) {
          const localVideoStream = call.localVideoStreams.find((stream) => { return stream.mediaStreamType === 'Video' });
          const cameras = await deviceManager.getCameras();
          const cameraToSwitch = cameras.find((item) => item.id === `camera:${camera}`);
          // Mac Safari can return a list without the stored id (stale id after reload) -
          // switchSource(undefined) throws, so keep the current source instead
          if (cameraToSwitch && cameraToSwitch.id !== localVideoStream.source?.id) {
            await localVideoStream.switchSource(cameraToSwitch);
          }
        } else if (call.isLocalVideoStarted) {
          await createLocalVideoStream();
        } else {
          setIsCam(true); // Update the state first
        }
      } catch (error) {
        console.error(
          error,
          "When Changing Camera createLocalVideoStream Failed"
        );
        appInsightTrack(__merchantId, __userId, "Error Changing Camera", "", error);
        // Optionally log to an analytics service
      }
    };

    handleCameraChange();
  }, [camera]); // Add dependencies for state and camera

  useEffect(() => {
    const startCamera = async () => {
      if (call && isCam && camera && !call.isLocalVideoStarted) {
        try {
          // Remove any dead stream left behind by a mid-call permission revoke,
          // otherwise startVideo fails with code=500 subCode=43002
          const staleStream = call.localVideoStreams.find(
            (stream) => stream.mediaStreamType === "Video"
          );
          if (staleStream) {
            try {
              await call.stopVideo(staleStream);
            } catch (stopError) {
              console.warn("Failed to remove stale video stream:", stopError);
            }
          }
          const newVideoStream = await createLocalVideoStream();
          newVideoStream && !(role === "Attendee" && isInstructorModeRef.current) && await call.startVideo(newVideoStream);
        } catch (error) {
          console.error("Failed to start video stream:", error);
          appInsightTrack(__merchantId, __userId, "Error start video", "", error);
        }
      }
    };

    startCamera();
  }, [call, isCam, camera]); // Ensure all relevant dependencies are included

  //Function For Creating Local Video Stream
  const createLocalVideoStream = async () => {
    if (!deviceManager) {
      console.error("Error accessing Speaker, Mic, Camera");
      return;
    }

    let camerasList = await deviceManager?.getCameras();
    if (camerasList.length === 0 && isCam) {
      // Mac Safari hides cameras until permission is granted in the current document -
      // after the full-page reload into /meeting the list is empty until we ask again
      try {
        await deviceManager.askDevicePermission({ audio: false, video: true });
        camerasList = await deviceManager.getCameras();
      } catch (error) {
        appInsightTrack(__merchantId, __userId, "Error asking camera permission", "", error);
      }
    }
    if (camerasList.length === 0) {
      console.error("No camera device found on the system");
      appInsightTrack(__merchantId, __userId, "No camera device found", "", navigator.userAgent);
      setIsCam(false);
      return;
    }
    let localCamera = camerasList.find(
      (item) => item.id === `camera:${camera}`
    );
    if (!localCamera) {
      // Revoking and re-granting camera permission can rotate deviceIds,
      // leaving the stored camera id stale - fall back to the first available camera
      localCamera = camerasList[0];
      const fallbackId = localCamera.id.replace("camera:", "");
      setCamera(fallbackId);
      sessionStorage.setItem("camera", fallbackId);
    }
    if (localCamera && isCam) {
      const localVideoStream = new LocalVideoStream(localCamera);
      const renderer = new VideoStreamRenderer(localVideoStream);
      await renderer.createView();
      renderer.dispose()
      setLocalVideoStream(localVideoStream);
      return localVideoStream;
    }
  };

  return (
    <>
      <BodyClassUpdater />
      {(!isHostNotJoined && !errorMessage && !hostBeRightBack) && <TopProgressBar call={call} isHostNotJoined={isHostNotJoined} hostBeRightBack={hostBeRightBack} vertualFocusedContent={vertualFocusedContent} setVertualFocusedContent={setVertualFocusedContent} />}

      {callAgent ? (
        <CallAgentProvider callAgent={callAgent}>
          {call ? (
            <CallProvider call={call}>
              <VideoGalleryScreen
                layout={layout}
                streamRef
                videoRef={videoRef}
                setIsSharing={setIsSharing}
                call={call}
                deviceManager={deviceManager}
                handleSelect={handleSelect}
                isCam={isCam}
                userName={userName}
                navbarOptionMenu={navbarOptionMenu}
                setLayout={setLayout}
                hostBeRightBack={hostBeRightBack}
                hostCommunicationUserId={hostCommunicationUserId}
                setHostBeRightBack={setHostBeRightBack}
                setIsHostNotJoined={setIsHostNotJoined}
                isHostNotJoined={isHostNotJoined}
                chatThreadClientRef={chatThreadClientRef}
                sessionStartTimeUTC={sessionStartTimeUTC}
                setNavbarOptionMenu={setNavbarOptionMenu}
                setIsActive={setIsActive}
                setVertualFocusedContent={setVertualFocusedContent}
                countRef={countRef}
                setIsContextualMenuOpen={setIsContextualMenuOpen}
                setExpendVideoTile={setExpendVideoTile}
                expendVideoTile={expendVideoTile}
              />
              <div className="controller">
                <Navbar
                  chatColor={chatColor}
                  streamRef={streamRef}
                  videoRef={videoRef}
                  setIsSharing={setIsSharing}
                  call={call}
                  deviceManager={deviceManager}
                  onSelect={handleSelect}
                  setIsCam={setIsCam}
                  isCam={isCam}
                  isActive={isActive}
                  userName={userName}
                  navbarOptionMenu={navbarOptionMenu}
                  setLayout={setLayout}
                  layout={layout}
                  hostBeRightBack={hostBeRightBack}
                  isHostNotJoined={isHostNotJoined}
                  camera={camera}
                  createLocalVideoStream={createLocalVideoStream}
                  isInstructorModeRef={isInstructorModeRef}
                  setVertualFocusedContent={setVertualFocusedContent}
                  vertualFocusedContent={vertualFocusedContent}
                  countRef={countRef}
                  setExpendVideoTile={setExpendVideoTile}
                />
              </div>
            </CallProvider>
          ) : (
            ""
          )}
        </CallAgentProvider>
      )
        : ""
      }
      <div
        className={`right-side-panel ${isDropdownOpen ? "mobile-bottom-menuup" : ""}`}
        id="mobileRightSidePanel"
        ref={panelRef}
        style={{ display: navbarOptionMenu ? "block" : "none" }}
      >
        <div className="section-settings custom-scroll">
          <div className="chat-window section-rightside-inner" style={{ display: navbarOptionMenu === "chat" ? "block" : "none" }}>
            {threadId ? (
              <ChatScreen
                setChatColor={setChatColor}
                chatColor={chatColor}
                messages={messages}
                token={token}
                communicationUserId={communicationUserId}
                navbarOptionMenu={navbarOptionMenu}
                userName={userName}
                disableChatRef={disableChatRef}
                role={role}
                onClose={() => { setNavbarOptionMenu(""); setIsActive(""); }}
              />
            ) : (
              "Chat is not enabled in the meeting"
            )}
          </div>

          <div style={{ display: navbarOptionMenu === "settings" ? "block" : "none" }} className="deviceSettingsSidebarWrap">
            <MediaDeviceSelector
              isClassScreen={true}
              onClose={() => { setNavbarOptionMenu(""); setIsActive(""); }}
            />
          </div>

          <div style={{ display: navbarOptionMenu === "people" ? "block" : "none" }}>
            <AttendeeList
              onClose={() => { setNavbarOptionMenu(""); setIsActive(""); }}
              onDropdownToggle={setIsDropdownOpen}
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default memo(ClassSessionScreen);